import { isNullOrUndefined } from "util";

export class DispatcherData {
    Users:WorkOrderTechnician[];
    UnAssignedWorkOrders: CommonAppointmentModel[]
}

export class WorkOrderTechnician {
    DeptName: string
    DepartmentName: string
    Message: string
    MessageType: string
    UserGroupID: number
    UserGroupName: string
    UserID: string
    UserName: string
    UserPhone: string
    AssignedTasks: DispatcherWorkOrder[]
    Apppointments: DispatcherWorkOrder[]
}

export class DispatcherWorkOrder {
  CustomerID?: string
  DepartmentID?: string
  DeptName?: string
  DispComment?: string
  DisplayName?:string
  Duration?:string
  AppointmentEndTime?: string
  EventType:string
  ID: string
  JobSIteContactPhone?:string
  JobSiteAddr?: string
  JobSiteDispName?:string
  JobSiteID: string
  JobSiteType?:string
  JobsiteContactName?:string
  JobsitePhoneNumber?:string
  JobsiteTypeID?:string
  Message?:string;
  MessageType?:string
  Name?:string
  //Note:string
  Priority?: string
  PriorityID?: string
  PromBeginTime: string
  PromDate : string
  ModifyDate : string
  AppointmentDate?:string;
  public get PromDateFormatted() : string|null {
  if ((this.PromDate != undefined) && (this.PromDate != null) && this.PromDate.toString().indexOf("T") > -1)
    return this.PromDate.toString().split("T")[0];
  else
    return "";
  }    
  PDate:Date
  PromEndTime: string
  PromID: string
  PromName: string
  ServiceType: string
  ServiceTypeName: string;
  AppointmentStartTime?:string
  State: string
  StateID: string
  SubState: string
  SubStateID: string
  WorkTicketStatusCode: string
  WorkTicketStatusID: string
  WorkTicketSubStatusCode: string
  WorkTicketSubStatusID: string
  TechDepartmentID?:string
  TechGroupName?:string
  TypeName?:string
  UserGroupID?:string
  UserID?:string
  UserName?:string
  WoNumber?: string
  WorkTicketNumber: string//new - This is not required so remove it later
  WorkTicketID: string;
  Helpers: any[];
  TypeID: string;
  TechName: string;
  TechID: string;
  AppointmentModel: any;
  HelperWorkOrderInfo: any;
  IsSchedule: boolean;

  AppointmentModifyDate: string;
  AppointmentNote: string;
  WorkTicketModifyDate: string;
  WorkTicketStatusName: string;
  WorkTicketSubStatusName: string;
}

export class DispatcherAppointment {
  ID: string;
  EndTime?: string
  EventType: string
 // Note: string;
  StartTime?: string
  TechDepartmentID?: string
  TechID: string;
  TechName: string;
  TypeID: string;
  TypeName: string;
  UserID: string;
  UserName?: string
  UserGroupID?: string
  DeptName?: string
  AppointmentDt?: string;
  ModifyDate?: string;
  DepartmentID?: string;
  AppointmentModel?: any;
  HelperWorkOrderInfo?: any;
  IsSchedule: boolean

  Priority?: string;
  PriorityID?: string;
  PromID?: string;
  StatusID?: string;
  SubStatusID?: string;
  WoNumber?: string;
  WorkTicketID?: string;
  WorkTicketNumber: string;
  AppointmentStatusID?: string;
  AppointmentSubStatusID?: string; 

  AppointmentModifyDate: string;
  AppointmentNote: string;
  WorkTicketModifyDate: string;
}

export class Request_AppointmentModel {
  ID: string;
  UserID: string;
  AppointmentTypeID: string;
  AppointmentDate: string;
  StartTime: string;
  EndTime: string;
  Note: string;
  WorkTicketID: string;
  StatusID: string;
  SubStatusID: string;
  ModifyDate: string;
  IsDirty: boolean;
  IsSchedule: boolean
  WorkTicketNumber: string;
  WoNumber: string;
  PriorityID?: string;
  Priority: string;
  PromID?: string;
  EstimateID: string;

  constructor() {
    this.ID = "00000000-0000-0000-0000-000000000000";
    this.UserID = "00000000-0000-0000-0000-000000000000";
    this.AppointmentTypeID = "00000000-0000-0000-0000-000000000000";
    this.AppointmentDate = "";
    this.StartTime = "";
    this.EndTime = "";
    this.Note = "";
    this.StatusID = "";
    this.SubStatusID = "";
    this.ModifyDate = "";
    this.WorkTicketID = "";
    this.PriorityID = "";
    this.Priority = "";
    this.PromID = "";
    this.EstimateID = "";
  }
}

export class Sch_AppointmentModel{
  //Name: string;
  //Date: string;
  //Time: string;
  //State: string;
  //DisplayState?: string;

  //
  RowID: string;
  UserID: string;
  UserName: string;
  UserPhone: string;
  UserGroupName: string;
  AppointmentID: string;
  WorkTicketID: string;
  WorkTicketNumber: string;
  DispComment: string;
  DepartmentID: string;
  DepartmentName: string;
  ServiceTypeName: string;
  AppointmentDate: string;
  CustomerID: string;
  JobSiteID: string;
  JobSiteDispName: string;
  JobSiteAddr: string;
  JobsiteTypeID: string;
  JobsiteContactName: string;
  JobsitePhoneNumber: string;
  PromID: string;
  PromName: string;
  PromBeginTime: string;
  PromEndTime: string;
  PriorityID: string;
  Priority: string;
  //ModifyDate: string;
 // Note: string;
  Action: string;
  WorkTicketStatusID: string;
  WorkTicketStatusCode: string;
  WorkTicketSubStatusID: string;
  WorkTicketSubStatusCode: string;
  AppointmentTypeID: string;
  AppointmentTypeCode: string;
  AppointmentStatusID: string;
  AppointmentStatusCode: string;
  AppointmentSubStatusID: string;
  AppointmentSubStatusCode: string;
  AppointmentStartTime: string;
  AppointmentEndTime: string;
  Helpers: any;
  TypeName: string;
  EventType: string;
  DeptName: string;
  TechDepartmentID: string;
  ID: string;
  TypeID: string;
  AppointmentDt: string;
  StartTime: string
  EndTime: string;
  TechName: string;
  TechID: string;

  AppointmentModifyDate: string;
  AppointmentNote: string;
  WorkTicketModifyDate: string;


  PDate?: Date;
  PromDate: string;
  UserGroupID: string;
  //

  constructor() {
    this.RowID="";
    this.UserID="";
    this.UserName="";
    this.UserPhone="";
    this.UserGroupName="";
    this.AppointmentID="";
    this.WorkTicketID="";
    this.WorkTicketNumber="";
    this.DispComment="";
    this.DepartmentID="";
    this.DepartmentName="";
    this.ServiceTypeName="";
    this.AppointmentDate="";
    this.CustomerID="";
    this.JobSiteID="";
    this.JobSiteDispName="";
    this.JobSiteAddr="";
    this.JobsiteTypeID="";
    this.JobsiteContactName="";
    this.JobsitePhoneNumber="";
    this.PromID="";
    this.PromName="";
    this.PromBeginTime="";
    this.PromEndTime="";
    this.PriorityID="";
    this.Priority="";
    //this.ModifyDate="";
    //this.Note="";
    this.Action="";
    this.WorkTicketStatusID="";
    this.WorkTicketStatusCode="";
    this.WorkTicketSubStatusID="";
    this.WorkTicketSubStatusCode="";
    this.AppointmentTypeID="";
    this.AppointmentTypeCode="";
    this.AppointmentStatusID="";
    this.AppointmentStatusCode="";
    this.AppointmentSubStatusID="";
    this.AppointmentSubStatusCode="";
    this.AppointmentStartTime="";
    this.AppointmentEndTime="";
    this.Helpers= [];
    this.TypeName="";
    if (!isNullOrUndefined(this.EventType) && this.EventType.toLowerCase() == "primarytech")
      this.EventType = "WorkOrder";
    else
      this.EventType = "Appointment";
    this.DeptName="";
    this.TechDepartmentID="";
    this.ID="";
    this.TypeID="";
    this.AppointmentDt = "";

    this.AppointmentModifyDate = "";
    this.AppointmentNote = "";
    this.WorkTicketModifyDate = "";
    this.UserGroupID = "0";
    //this.StartTime = this.AppointmentStartTime;
    //this.EndTime = this.AppointmentEndTime;
    //this.TechName = this.UserName;
    //this.TechID = this.UserID;
  }
}

/** To be used to bind Unassigned grid, eventdata */
export class CommonAppointmentModel {
  //#region User specific properties
  AppointmentTypeCode: string;
  DepartmentName: string;
  RowID: string;
  UserGroupName: string;
  UserPhone: string;
  //#endregion

  //#region Unassigned grid specific properties

  Duration: string;
  ID: string;
  PDate: Date;
  PromDate: string;
  //#endregion

  //#region Board related properties
  DeptName: string; // used in unassigned grid also
  EndTime: string;
  EventType: string;
  Message: string;
  MessageType: string;
  StartTime: string;
  TechDepartmentID?: string
  TechID: string; // its a userid
  TechName: string;
  UserGroupID: string;
  //#endregion

  //#region Common properties
  Action: string;
  AppointmentDate: string;
  AppointmentEndTime: string;
  AppointmentID: string;
  AppointmentModifyDate: string;
  AppointmentNote: string;
  AppointmentStartTime: string;
  AppointmentStatusCode: string;
  AppointmentStatusID: string;
  AppointmentSubStatusCode: string;
  AppointmentSubStatusID: string;
  AppointmentTypeID: string;
  CustomerID: string;
  DepartmentID: string;
  DispComment: string;
  Helpers: any[];
  JobSiteAddr: string;
  JobsiteContactName: string;
  JobSiteDispName: string;
  JobSiteID: string;
  JobsitePhoneNumber: string;
  JobsiteTypeID: string;
  Priority: string;
  PriorityID: string;
  PromBeginTime: string;
  PromEndTime: string;
  PromID: string;
  PromName: string;
  ServiceTypeName: string;
  UserID: string;
  UserName: string;
  WorkTicketID: string;
  WorkTicketModifyDate: string;
  WorkTicketNumber: string;
  WorkTicketStatusCode: string;
  WorkTicketStatusID: string;
  WorkTicketSubStatusCode: string;
  WorkTicketSubStatusID: string;
  WorkTicketStatusName: string;
  WorkTicketSubStatusName: string;
  //#endregion

  constructor() {
    //#region User specific properties
    this.AppointmentTypeCode = "";
    this.DepartmentName = "";
    this.RowID = "00000000-0000-0000-0000-000000000000";
    this.UserGroupName = "";
    this.UserPhone = "";
    //#endregion

    //#region Unassigned grid specific properties
    this.DeptName = "";
    this.Duration = "";
    this.ID = "00000000-0000-0000-0000-000000000000";
    //this.PDate= Date;
    this.PromDate = "";
    //#endregion

    //#region Board related properties
    this.TechDepartmentID = "";
    this.TechName = "";
    this.StartTime = "";
    this.EndTime = "";
    this.TechID = "";// its a userid
    //#endregion

    //#region Common properties
    this.Action = "";
    this.AppointmentDate = "";
    this.AppointmentEndTime = "";
    this.AppointmentID = "";
    this.AppointmentModifyDate = "";
    this.AppointmentNote = "";
    this.AppointmentStartTime = "";
    this.AppointmentStatusCode = "";
    this.AppointmentStatusID = "";
    this.AppointmentSubStatusCode = "";
    this.AppointmentSubStatusID = "";
    this.AppointmentTypeID = "";
    this.CustomerID = "";
    this.DepartmentID = "";
    this.DispComment = "";
    this.Helpers = [];
    this.JobSiteAddr = "";
    this.JobsiteContactName = "";
    this.JobSiteDispName = "";
    this.JobSiteID = "";
    this.JobsitePhoneNumber = "";
    this.JobsiteTypeID = "";
    this.Priority = "";
    this.PriorityID = "";
    this.PromBeginTime = "";
    this.PromEndTime = "";
    this.PromID = "";
    this.PromName = "";
    this.ServiceTypeName = "";
    this.UserID = "";
    this.UserName = "";
    this.WorkTicketID = "";
    this.WorkTicketModifyDate = "";
    this.WorkTicketNumber = "";
    this.WorkTicketStatusCode = "";
    this.WorkTicketStatusID = "";
    this.WorkTicketSubStatusCode = "";
    this.WorkTicketSubStatusID = "";
    this.WorkTicketStatusName = "";
    this.WorkTicketSubStatusName = "";
    if (!isNullOrUndefined(this.EventType) && this.EventType.toLowerCase() == "primarytech")
      this.EventType = "WorkOrder";
    else
      this.EventType = "Appointment";
    //#endregion
  }
}